import "core-js/modules/es.function.name";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  props: ['teamId'],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        name: ""
      },
      rules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  datas = JSON.parse(JSON.stringify(data)); // let teamVibe = data.team_vibe ? JSON.parse(data.team_vibe) : [];
                  // datas.team_vibe = teamVibe.map(item => { return { value: item } })
                  // datas.venue_id = ""

                  _this.formData.name = datas.name;
                  _this.formData.id = datas.id;
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this2.formData.id ? 'updateAbilityTags' : 'addAbilityTags';
                    var data = JSON.parse(JSON.stringify(_this2.formData));

                    _this2.$api[reqFn](_objectSpread(_objectSpread({}, data), {}, {
                      team_id: _this2.teamId
                    })).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success('操作成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};